/** Breakpoint (px) below which the layout switches to mobile/narrow mode.
 * Registered in the MUI theme as the 'sidebar_breakpoint' custom breakpoint and used in
 * JS via useResponsiveMobile / sidebarConfig.mobileBreakpoint. */
export const SIDEBAR_BREAKPOINT = 960;

/** Breakpoint (px) for extra-small / very narrow viewports.
 * Registered in the MUI theme as the 'w_xs' custom breakpoint. */
export const W_XS_BREAKPOINT = 450;
